export default "__VITE_ASSET__CxZ_xjdv__"